import { render } from "./AddNewPhysician.vue?vue&type=template&id=44feaed6"
import script from "./AddNewPhysician.vue?vue&type=script&lang=js"
export * from "./AddNewPhysician.vue?vue&type=script&lang=js"

import "./AddNewPhysician.vue?vue&type=style&index=0&id=44feaed6&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/physicians/AddNewPhysician.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "44feaed6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('44feaed6', __exports__)) {
    console.log('reload')
    api.reload('44feaed6', __exports__)
  }
  
  module.hot.accept("./AddNewPhysician.vue?vue&type=template&id=44feaed6", () => {
    console.log('re-render')
    api.rerender('44feaed6', render)
  })

}


export default __exports__